// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b1dc941a","453":"a89f3c95"}[chunkId] + ".chunk.js";
};